<template>
    <!-- 添加数据2 -->

    <a-modal title="修改用户" v-model:open="open" @ok="handleOk" class="modals">
        <div class="push-input">
            <a><span class="startColor">*</span>用户名称：</a>
            <a-input v-model:value="pushData.username" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>电话号码：</a>
            <a-input v-model:value="pushData.phoneNumber" maxlength="11" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>部门选择：</a>
            <a-select v-model:value="pushData.deptId" class="push-data">
                <a-select-option v-for="p in depts" :key="p.id" :value="p.id">{{ p.deptName }}</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>权限选择：</a>
            <a-select v-model:value="pushData.permissionsId" class="push-data">
                <a-select-option v-for="p in permissions" :key="p.id" :value="p.id">{{ p.permissionName
                    }}</a-select-option>
            </a-select>
        </div>

        <div class="push-input">
            <a>电子邮箱：</a>
            <a-input v-model:value="pushData.email" maxlength="30" class="push-data" />
        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">返回</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { updateUsers, listDepts, listPermissions } from '@/api/service';
import { generateSignHeaders } from '@/utils/sign';
import { message } from 'ant-design-vue';
import { ref } from 'vue';
export default {
    name: 'editComponent',
    methods: {
        getUploadHeaders() {
            return {
                'token': localStorage.getItem('token'),
                'tenantId': localStorage.getItem('tenantId'),
                ...generateSignHeaders()
            };
        }
    },
    setup() {
        const loading = ref(false);//添加提交时的加载
        const pushData = ref({});//提交数据
        const open = ref(false);//是否打开
        const depts = ref([]);//父级菜单
        const permissions = ref([]);//父级菜单
        const imageUrl = ref('');//头像
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }
        //查询部门列表
        const listDept = async () => {
            const response = await listDepts();
            if (response.code === 200) {
                depts.value = response.data;
            }
        }
        //查询权限列表
        const listpermissions = async () => {
            const response = await listPermissions();
            if (response.code === 200) {
                permissions.value = response.data;
            }
        }

        //提交数据
        const handleOk = async () => {
            loading.value = true;
            const response = await updateUsers(pushData.value);
            if (response.code === 200) {
                message.success('添加成功');
                pushData.value = {};
                imageUrl.value = '';
                loading.value = false;
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                loading.value = false;
                open.value = false;
                return false;
            }
        }
        listDept();
        listpermissions();
        return {
            loading,
            open,
            pushData,
            listDept,
            listpermissions,
            permissions,
            depts,
            parent,
            toAddCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.push-input {
    margin-top: 20px;
    display: block;
}

.push-avatar {
    margin-top: 20px;
    display: inline-flex;
}

.push-avatar {
    margin-top: 20px;
    display: inline-flex;
}

.modals {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 400px;
}

.push-data {
    width: 80%;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}
</style>